import { FC, useState } from 'react';
import Button from '@/components/Button';
import Form from '@/components/Form';
import InputWrapper from '@/components/Form/InputWrapper';
import { gaPushEvent } from '@/utils/analytics';
import { ErrorException } from '@/models/error';
import NewPasswordFields from '@/components/NewPasswordFields';
import { toast } from 'react-toastify';
import { AdminService } from '@/services/admin.service';
import useSession from '@/hooks/useSession';
import { Role } from '@/models/user';

interface NewUserFormProps {
  onSubmit: () => void;
}
const NewUserForm: FC<NewUserFormProps> = ({ onSubmit }) => {
  const {
    session: { organizations, roles },
    orgIndex,
  } = useSession();

  const [submitted, setSubmitted] = useState(false);
  const [fetching, setFetching] = useState(false);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    setFetching(true);
    try {
      const success = await AdminService.addUser(
        formData.get('fields[email]') as string,
        formData.get('password') as string,
        formData.get('fields[name]') as string,
        roles.includes(Role.SUPER_USER_ADMIN)
          ? organizations[orgIndex].id
          : undefined
      );

      console.log('sign up success', success);

      if (!success) {
        throw new Error('Sign up failed');
      }
      gaPushEvent('add_user');
      setSubmitted(true);
      onSubmit();
    } catch (err) {
      const error = err as ErrorException;
      console.log(error);
      toast(error.message, { type: 'error' });
    } finally {
      setFetching(false);
    }
  };

  return (
    <section>
      <Form onSubmit={handleSubmit}>
        <InputWrapper>
          <input type="text" id="name" name="fields[name]" required />
          <label htmlFor="name">Full name:</label>
        </InputWrapper>
        <InputWrapper>
          <input type="email" id="email" name="fields[email]" required />
          <label htmlFor="email">Email:</label>
        </InputWrapper>
        <NewPasswordFields />

        <Button
          variation="alt"
          disabled={fetching || submitted}
          loading={fetching}
          loadingText="Adding User"
        >
          Add User
        </Button>
      </Form>
    </section>
  );
};

export default NewUserForm;
